import styled from "styled-components";

const Container = styled.div`
  text-align: center;
  > h3,
  h2 {
    margin-bottom: 1rem;
  }
`;

export { Container };
